import { Axios } from 'utils'
import { Company } from 'types/models'
import {
  ItemResponseType,
  ListPaginationParams,
  ListResponseType,
} from './types'

export const useCompaniesService = () => {
  const getCompanies = async (pagination?: ListPaginationParams) => {
    try {
      const response = await Axios.get<ListResponseType<Company>>(
        `/companies`,
        {
          params: pagination
            ? {
                offset: pagination.currentPage * pagination.itemsPerPage,
                limit: pagination.itemsPerPage,
              }
            : undefined,
        }
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const createCompany = async (company: Company) => {
    const response = await Axios.post('/companies', company)
    return response.data
  }

  const editCompany = async (company: Company) => {
    const response = await Axios.put(`/companies/${company?.id}`, company)
    return response.data
  }

  const uploadCompanyFiles = async (file) => {
    if (!file || typeof file === 'string') return file

    const fileBinary = await file?.arrayBuffer()

    const response = await Axios.post<ItemResponseType<{ file_url: string }>>(
      `/companies/upload_file`,
      fileBinary,
      {
        params: {
          path: `icon/${file?.name}`,
        },
      }
    )
    return response?.data
  }

  const getCurrentAndDescendant = async () => {
    const response = await Axios.get<ListResponseType<Company>>(
      '/companies/current_and_descendants'
    )

    return response?.data
  }

  return {
    uploadCompanyFiles,
    getCurrentAndDescendant,
    getCompanies,
    createCompany,
    editCompany,
  }
}

export default useCompaniesService
